import axios from '@axios'

const PREFIX = '/parametrizacao-template-proposta'

export default {

  getTemplates(page, pageSize, filtros) {
    return axios.post(`${PREFIX}?page=${page}&pageSize=${pageSize}`, filtros)
  },

  salvarTemplate(template) {
    // Envia template possivelmente como FormData (multipart/form-data)
    return axios.post(`${PREFIX}/add`, template)
  },

  updateTemplate(id, template) {
    // Envia template possivelmente como FormData (multipart/form-data)
    return axios.put(`${PREFIX}/${id}`, template)
  },

  deleteTemplate(id) {
    return axios.delete(`${PREFIX}/${id}`)
  },

  getTemplateById(id) {
    return axios.get(`${PREFIX}/${id}`)
  },
  getTemplatesResumidos(tipoProposta) {
    const params = tipoProposta ? `?tipoProposta=${tipoProposta}` : ''
    return axios.get(`${PREFIX}/resumidos${params}`)
  },
}
